import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MaintenanceReview from './maintenance-review';
import MaintenanceReviewDetail from './maintenance-review-detail';
import MaintenanceReviewUpdate from './maintenance-review-update';
import MaintenanceReviewDeleteDialog from './maintenance-review-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MaintenanceReviewUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MaintenanceReviewUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MaintenanceReviewDetail} />
      <ErrorBoundaryRoute path={match.url} component={MaintenanceReview} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MaintenanceReviewDeleteDialog} />
  </>
);

export default Routes;
